import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {SheetId} from '@mintdata/mint-kit/api/models/Identifiers';
import {Popover} from '@mintdata/mint-kit/impl/components/popover/Popover';
import {
    PopupDismissedKeys,
    PopupDismissedReason,
    PopupDismissedReasons
} from '@mintdata/mint-kit/impl/components/popover/PopupDismissedReason';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import bind from 'bind-decorator';

import * as classnames from 'classnames/bind';
import * as React from 'react';
import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';
import {AnySheet} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SheetTypes';

const styles = require('./CellSettingsSubMenu.less');
const cx = classnames.bind(styles);

export interface ICellSettingsSubMenuProps
{
    focusedSheetId:SheetId;

    onChange?:(color:string) => void;
    className?:string;

    onShow?:() => void;
    onHide?:() => void;
}

export interface ICellSettingsSubMenuState
{
    isPopoverOpen:boolean;
}

export class CellSettingsSubMenu extends React.Component<ICellSettingsSubMenuProps, ICellSettingsSubMenuState>
{
    private readonly _popoverId:string = IdUtil.newComponentId();

    private _parentRef;

    constructor(props)
    {
        super(props);

        this.state = {
            isPopoverOpen: false,
        };
    }

    @bind
    private _setCurrentSwatchRef(ref):void
    {
        this._parentRef = ref;
    }

    @bind
    private _togglePopover(e:React.MouseEvent<HTMLElement>):void
    {
        e.stopPropagation();
        e.preventDefault();

        this.setState((prevState) =>
        {
            const isPopoverOpen = !prevState.isPopoverOpen;

            const {onHide, onShow} = this.props;

            isPopoverOpen
                ? onShow && onShow()
                : onHide && onHide();

            if( !isPopoverOpen ) this._focusMesh(true);

            return {isPopoverOpen};
        });
    }

    @bind
    private _closePopover(popupDismissedReason?:PopupDismissedReason):void
    {
        this.setState({
            isPopoverOpen: false,
        });

        const {onHide} = this.props;
        onHide && onHide();

        if( !popupDismissedReason ) return;

        if( popupDismissedReason.reason == PopupDismissedReasons.Keyboard &&
            popupDismissedReason.data &&
            popupDismissedReason.data.key &&
            popupDismissedReason.data.key == PopupDismissedKeys.ESC
        )
        {
            this._focusMesh();
        }
    }

    @bind
    private _focusMesh(withTimeout:boolean = false):void
    {
        const {focusedSheetId} = this.props;

        if( !focusedSheetId ) return;

        const {mesh, workbook} = controllers.ui.spreadsheets;
        const ctx:IWSPMeshContext = workbook.getMeshContextBySheetId(focusedSheetId);

        if( withTimeout )
            setTimeout(() => mesh.focusMesh(ctx), 0);
        else
            mesh.focusMesh(ctx);
    }

    private _renderPopover()
    {
        const {className} = this.props;

        return (
            <Popover
                id={this._popoverId}
                isModal={false}
                popupSource={this._parentRef}
                sourceAnchor={SourceAnchor.LeftBottom}
                popupAnchor={PopupAnchor.LeftTop}
                onDismissed={this._closePopover}
            >
                <div className={cx('subMenuContent', className)}>
                    {this.props.children}
                </div>
            </Popover>
        );
    }

    public render()
    {
        const {isPopoverOpen} = this.state;

        return (
            <div
                className={cx('subMenu')}
                onClick={this._togglePopover}
                ref={this._setCurrentSwatchRef}
            >
                {isPopoverOpen && this._renderPopover()}
            </div>
        );
    }
}
